import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=a1445930&"
import script from "./list-item.vue?vue&type=script&lang=js&"
export * from "./list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports